/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_CommunalInputs */

const en_val_communal = /** @type {(inputs: Val_CommunalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Communal`)
};

const es_val_communal = /** @type {(inputs: Val_CommunalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comunitario`)
};

const fr_val_communal = /** @type {(inputs: Val_CommunalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Communautaire`)
};

const de_val_communal = /** @type {(inputs: Val_CommunalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemeinschaftlich`)
};

const ja_val_communal = /** @type {(inputs: Val_CommunalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`共有スペース`)
};

const zh_val_communal = /** @type {(inputs: Val_CommunalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`共享空间`)
};

const ar_val_communal = /** @type {(inputs: Val_CommunalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جماعي / مشاع`)
};

const id_val_communal = /** @type {(inputs: Val_CommunalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komunal`)
};

const it_val_communal = /** @type {(inputs: Val_CommunalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uso Comune`)
};

const ru_val_communal = /** @type {(inputs: Val_CommunalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общественное пространство`)
};

const pt_val_communal = /** @type {(inputs: Val_CommunalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comunitário`)
};

const ko_val_communal = /** @type {(inputs: Val_CommunalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`공용`)
};

/**
* | output |
* | --- |
* | "Communal" |
*
* @param {Val_CommunalInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_communal = /** @type {((inputs?: Val_CommunalInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_CommunalInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_communal(inputs)
	if (locale === "es") return es_val_communal(inputs)
	if (locale === "fr") return fr_val_communal(inputs)
	if (locale === "de") return de_val_communal(inputs)
	if (locale === "ja") return ja_val_communal(inputs)
	if (locale === "zh") return zh_val_communal(inputs)
	if (locale === "ar") return ar_val_communal(inputs)
	if (locale === "id") return id_val_communal(inputs)
	if (locale === "it") return it_val_communal(inputs)
	if (locale === "ru") return ru_val_communal(inputs)
	if (locale === "pt") return pt_val_communal(inputs)
	return ko_val_communal(inputs)
});